import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'

export const RowLayout = ({ title, children, subtitle = '' }) => (
  <div className="layout-row">
    <div className="layout-row__title justify-center column">
      <Typography.Body2 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
        {title}
      </Typography.Body2>
      {subtitle && (
        <Typography.Body2 className={'layout-row__subtitle'}>
          {subtitle}
        </Typography.Body2>
      )}
    </div>
    <div className="layout-row__content">{children}</div>
  </div>
)
